import React , { useState , useEffect } from 'react';
import PropTypes from 'prop-types';
import './LoaderScreen.scss';
import backgroundVideo from '../../images/videos/loader-screen-video.mp4'
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import LoadingAnime from '../../Utils/crane-operation.json'

const LoaderScreen = () => {


  const navigate = useNavigate();



  useEffect(() => {

    const timer = setTimeout(() => {
      navigate('/Home')
    }, 4000);

    return () => {
      clearTimeout(timer);
    } 
        
  }, []);

  return (
    <div className="mask-container">
      {/* <div className="text-background">
        <video disablePictureInPicture autoPlay muted loop id="video-background">
          <source src={backgroundVideo} type="video/mp4" />
        </video>
        <h1 className={`masked-text text-[200px] `}>{count}%</h1>
      </div>
      <div className={`bg-OrangeTheme w-full h-4  absolute bottom-4 origin-left flex items-center justify-start px-4 duration-500`} style={{transform: `scaleX(${count}%)` }}>
      </div> */}
      {/* <div class="loader-container">
        <div class="slice"></div>
        <div class="slice"></div>
        <div class="slice"></div>
        <div class="slice"></div>
        <div class="slice"></div>
        <div class="slice"></div>
      </div> */}

        {/* <Lottie
          animationData={LoadingAnime}
          loop={true}
          style={{width: "100%" , height: "330px" , objectFit: "cover" }}
        /> */}


        <img src={require('../../images/loader-anime.gif')} className='w-full max-w-[700px] h-full object-contain' alt="" />


    {/* <div class="sun">
      <div class="center"></div>
      <div class="ray r-1"></div>
      <div class="ray r-2"></div>
      <div class="ray r-3"></div>
      <div class="ray r-4"></div>
      <div class="ray r-5"></div>
      <div class="ray r-6"></div>
      <div class="ray r-7"></div>
      <div class="ray r-8"></div>
    </div> */}


    {/* <figure>
      <div style={{"--i": 1}}></div>
      <div style={{"--i": 2}}></div>
      <div style={{"--i": 3}}></div>
      <div style={{"--i": 4}}></div>
      <div style={{"--i": 5}}></div>
      <div style={{"--i": 6}}></div>
      <div style={{"--i": 7}}></div>
      <div style={{"--i": 8}}></div>
      <div style={{"--i": 9}}></div>
      <div style={{"--i": 10}}></div>
      <div style={{"--i": 11}}></div>
      <div style={{"--i": 12}}></div>
  </figure> */}

  </div>
  );
}

LoaderScreen.propTypes = {};

LoaderScreen.defaultProps = {};

export default LoaderScreen;
